import { SubscriptionSummary, MixSummary } from 'ggApp/types/graphql';

import ActionsTypes from './actionTypes';

interface SetSubscriptionSummaryAction {
    type: typeof ActionsTypes.SET_SUBSCRIPTION_SUMMARY;
    payload: SubscriptionSummary[];
}

interface SetMixSummaryAction {
    type: typeof ActionsTypes.SET_MIX_SUMMARY;
    payload: MixSummary | null;
}

export function setSubscriptionSummary(
    subscriptionSummary: SubscriptionSummary[],
): SetSubscriptionSummaryAction {
    return {
        type: ActionsTypes.SET_SUBSCRIPTION_SUMMARY,
        payload: subscriptionSummary,
    };
}

export function setMixSummary(mixSummary: MixSummary): SetMixSummaryAction {
    return {
        type: ActionsTypes.SET_MIX_SUMMARY,
        payload: mixSummary,
    };
}

export type Action = SetSubscriptionSummaryAction | SetMixSummaryAction;
export type ActionCreator = typeof setSubscriptionSummary | typeof setMixSummary;
